import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Transition as _Transition, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex-1 inline-flex flex-col justify-center items-start pl-2 gap-1" }
const _hoisted_2 = { class: "self-stretch truncate h-4 justify-center text-white text-sm font-normal font-['Roboto'] leading-5" }
const _hoisted_3 = {
  key: 0,
  class: "self-stretch truncate h-3.5 justify-center text-neutral-400 text-[10px] font-semibold font-['Roboto'] leading-4"
}
const _hoisted_4 = {
  key: 1,
  class: "self-stretch inline-flex justify-start items-center gap-1"
}
const _hoisted_5 = { class: "absolute right-0 z-10 w-full origin-top-right rounded-md shadow-lg ring-1 bg-[#1C1D21] ring-black ring-opacity-5 focus:outline-none overflow-hidden" }
const _hoisted_6 = { class: "text-white" }
const _hoisted_7 = { class: "text-white max-h-[200px] overflow-y-auto" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "self-stretch justify-start text-white text-sm font-normal font-['Roboto'] leading-5 line-clamp-2" }
const _hoisted_10 = {
  key: 0,
  class: "self-stretch justify-start text-neutral-400 text-[10px] font-semibold font-['Roboto'] leading-4"
}
const _hoisted_11 = {
  key: 1,
  class: "self-stretch inline-flex justify-start items-center gap-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative w-full z-[100]",
    tabindex: "1",
    onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
      id: "headerLocationSelector",
      class: _normalizeClass([[(_ctx.vg_locationSelected.id)?'text-white':'text-[#878686]'], "py-2 px-1 text-[#878686] flex items-center mt-2 rounded-md select-none cursor-pointer w-full"])
    }, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "pl-2" }, [
        _createElementVNode("svg", {
          width: "12",
          height: "18",
          viewBox: "0 0 12 18",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M6.00033 0.666504C2.77533 0.666504 0.166992 3.27484 0.166992 6.49984C0.166992 10.8748 6.00033 17.3332 6.00033 17.3332C6.00033 17.3332 11.8337 10.8748 11.8337 6.49984C11.8337 3.27484 9.22533 0.666504 6.00033 0.666504ZM1.83366 6.49984C1.83366 4.19984 3.70033 2.33317 6.00033 2.33317C8.30033 2.33317 10.167 4.19984 10.167 6.49984C10.167 8.89984 7.76699 12.4915 6.00033 14.7332C4.26699 12.5082 1.83366 8.87484 1.83366 6.49984ZM3.91699 6.49984C3.91699 5.34924 4.84973 4.4165 6.00033 4.4165C6.74463 4.4165 7.43239 4.81358 7.80454 5.45817C8.1767 6.10276 8.1767 6.89692 7.80454 7.5415C7.43239 8.18609 6.74463 8.58317 6.00033 8.58317C4.84973 8.58317 3.91699 7.65043 3.91699 6.49984Z",
            fill: "white"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.vg_locationSelected.name ? _ctx.vg_locationSelected.name: 'Select A Location'), 1),
        (_ctx.vg_locationSelected.businessBrandProfile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.vg_locationSelected.businessBrandProfile?.name), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M2.60753 12.2492H11.3925C12.2909 12.2492 12.8509 11.275 12.4017 10.4992L8.0092 2.91C7.56003 2.13417 6.44003 2.13417 5.99086 2.91L1.59836 10.4992C1.1492 11.275 1.7092 12.2492 2.60753 12.2492ZM7.00003 8.16583C6.6792 8.16583 6.4167 7.90333 6.4167 7.5825V6.41583C6.4167 6.095 6.6792 5.8325 7.00003 5.8325C7.32086 5.8325 7.58336 6.095 7.58336 6.41583V7.5825C7.58336 7.90333 7.32086 8.16583 7.00003 8.16583ZM7.58336 10.4992H6.4167V9.3325H7.58336V10.4992Z",
                  fill: "#EF4444"
                })
              ], -1),
              _createElementVNode("div", { class: "flex-1 justify-center text-red-500 text-[10px] font-semibold font-['Roboto'] leading-4" }, "Add to a Brand Profile", -1)
            ]))]))
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "px-1" }, [
        _createElementVNode("svg", {
          width: "12",
          height: "8",
          viewBox: "0 0 12 8",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M1.41 0.294922L6 4.87492L10.59 0.294922L12 1.70492L6 7.70492L0 1.70492L1.41 0.294922Z",
            fill: "white"
          })
        ])
      ], -1))
    ], 2),
    _withDirectives(_createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: location.id,
                  class: "w-full bg-zinc-700 shadow-[0px_5px_5px_0px_rgba(0,0,0,0.20)] shadow-[0px_3px_14px_0px_rgba(0,0,0,0.12)] shadow-[0px_8px_10px_0px_rgba(0,0,0,0.14)] inline-flex flex-col justify-start items-start overflow-hidden"
                }, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (_ctx.selectTheLocation(location)),
                    class: _normalizeClass(["w-full overflow-hidden px-2 py-1 inline-flex flex-col justify-center items-start break-words cursor-pointer transition ease-out duration-100 text-sm hover:bg-theme-green/[0.5]", (_ctx.vg_locationSelected.id==location.id)?'bg-secondary/[0.33]':'bg-theme-modalbg'])
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(location.name), 1),
                    (location.businessBrandProfile)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(location.businessBrandProfile?.name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("div", { class: "flex-1 justify-center text-red-500 text-[10px] font-semibold font-['Roboto'] leading-4" }, "Add to a Brand Profile", -1),
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 14 14",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M2.60741 12.2492H11.3924C12.2907 12.2492 12.8507 11.275 12.4016 10.4992L8.00907 2.91C7.55991 2.13417 6.43991 2.13417 5.99074 2.91L1.59824 10.4992C1.14907 11.275 1.70907 12.2492 2.60741 12.2492ZM6.99991 8.16583C6.67907 8.16583 6.41657 7.90333 6.41657 7.5825V6.41583C6.41657 6.095 6.67907 5.8325 6.99991 5.8325C7.32074 5.8325 7.58324 6.095 7.58324 6.41583V7.5825C7.58324 7.90333 7.32074 8.16583 6.99991 8.16583ZM7.58324 10.4992H6.41657V9.3325H7.58324V10.4992Z",
                              fill: "#EF4444"
                            })
                          ], -1)
                        ]))]))
                  ], 10, _hoisted_8)
                ]))
              }), 128))
            ]),
            (_ctx.vg_isUserTypeSuper)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.newLocation && _ctx.newLocation(...args)))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("div", { class: "border-t border-theme-grey text-theme-green bg-theme-modalbg cursor-pointer px-2 text-md align-baseline" }, [
                    _createElementVNode("span", { class: "text-3xl" }, "+"),
                    _createTextVNode(),
                    _createElementVNode("span", { class: "align-bottom leading-9" }, "New Location")
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.toggle]
    ])
  ], 32))
}